import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export function Input({ label, error, className = '', id, ...props }: InputProps) {
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label htmlFor={id} className="text-xs font-medium text-[#8b8d9a]">
          {label}
        </label>
      )}
      <input
        id={id}
        className={`
          w-full rounded-md border bg-[#1a1b23] px-3 py-2
          text-sm text-[#ededf0] placeholder:text-[#5e6070]
          transition-colors duration-150
          ${error ? 'border-danger/60 focus:border-danger' : 'border-white/[0.1] focus:border-accent/60'}
          outline-none focus:ring-1 ${error ? 'focus:ring-danger/20' : 'focus:ring-accent/20'}
          ${className}
        `}
        {...props}
      />
      {error && <p className="text-xs text-danger/80">{error}</p>}
    </div>
  );
}
